import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import AddressField from '../../components/common/AddressField';
import NewLocationForm from '../../components/locations/NewLocationForm';
import SearchLocationForm from '../../components/locations/SearchLocationForm';

const MapboxDemo = () => {
  return (
    <Grid container spacing={2} padding={2} justifyContent='center' alignItems='center'>
      <Grid item xs={12} md={4}>
        <Typography variant='h2'>Address Input</Typography>
        <AddressField />
      </Grid>
      <Grid item xs={12} md={4}>
        <NewLocationForm />
      </Grid>
      <Grid item md={4}>
        <SearchLocationForm />
      </Grid>
    </Grid>
  );
};

export default MapboxDemo;